import React from 'react';
import Dashboard from "../../components/dashboard/Dashboard";
import ActivityMonitorHOC from '../ActivityMonitorHOC';

const DashboardPage = (props) => (
  <Dashboard {...props}/>
);

export default ActivityMonitorHOC(DashboardPage);